/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React from 'react';
import {
  FlatList,
  Image,
  Platform,
  RefreshControl,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';

import {getFullImageUrl} from '../../../../common/utils/image';
import {StackParams} from '../../../../data/types/navigation';
import globalStyle from '../../../styles/globalStyle';
import {Loader} from '../../Loader';
import {styles} from './styles';

type NavigationProps = StackNavigationProp<StackParams, 'Details'>;

type Props = {
  isCatalogue: boolean;
  refreshList: any;
  refreshing: boolean;
  datas: {nom: string; imageUrl: string}[];
  isLoading: boolean;
  libelle: string;
  titleParent: string;
};
export function ListCategorie(props: Props) {
  const {
    datas,
    isCatalogue,
    libelle,
    isLoading,
    refreshing,
    refreshList,
    titleParent,
  } = props;

  const {navigate} = useNavigation<NavigationProps>();

  const handleMove = ({item}: {item: any}) => {
    navigate('Details', {
      id: item.id,
      path: Platform.OS === 'web' ? titleParent + ' > ' + item.nom : item.nom,
      nom: item.nom,
      isCatalogue: isCatalogue,
    });
  };

  const containerStyle =
    Platform.OS === 'web'
      ? [
          styles.ListContainer,
          globalStyle.containerFluid,
          globalStyle.fullEcranWeb,
        ]
      : styles.ListContainer;
  return (
    <View style={containerStyle}>
      <Text style={styles.ListLibelle}>{libelle}</Text>
      {isLoading ? (
        <Loader />
      ) : (
        <FlatList
          data={datas || []}
          refreshControl={
            <RefreshControl refreshing={refreshing} onRefresh={refreshList} />
          }
          renderItem={({item}: {item: any}) => (
            <TouchableOpacity
              style={styles.ListItemInRow}
              onPress={() => {
                handleMove({item});
              }}>
              <Image
                style={styles.ListItemLogo}
                source={{
                  uri: getFullImageUrl(item.imageUrl),
                }}
              />
              <Text style={styles.ListItemFont}>{item.nom}</Text>
            </TouchableOpacity>
          )}
        />
      )}
    </View>
  );
}
